import React from "react";
import "./ContactUsPage.css";
import PropTypes from "prop-types";
import SocialHandles from "../../components/socialHandles/SocialHandles";
import { baseUrl } from "../../constants";

const ContactUsPage = () => {
  return (
    <div className="main-div flex flex-col items-center justify-evenly">
      <button className="contact-us-btn bg-red-400 rounded-full px-4 py-2 min-w-[60vw] flex items-center justify-between space-x-4 mt-10">
        <img src={`/image/gmail.png`} width="50px" />
        <a
          href="mailto:hladcontact@gmail.com"
          className="write-mail-text text-[4rem] text-white"
        >
          Write a Mail to us
        </a>
      </button>
      <span className="contact-text text-xl mt-2">Or Reach Out Via</span>
      <SocialHandles />
    </div>
  );
};

ContactUsPage.propTypes = {
  actions: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  homePageReducer: PropTypes.object.isRequired,
};

export default ContactUsPage;
